// CSS 

//Lib  

// Event, Dialog
import EventBus from "@/event/EventBus";

// Api 

// Constant
import { POPUP_ID, POPUP_NAME } from "@/constant/baseConstant";
import { EXTRA_SERVICE_TAB } from "@/constant/extraService";

// Extend
import baseExtraService from '@/scripts/extraService/baseExtraService';

// Components
import ExtraServiceHistory from "@/views/ExtraService/ExtraServiceHistory";
import SelectionExtraService from "@/views/ExtraService/SelectionExtraService";
import ExtraServiceExpandImageThreshold from "@/views/modal/ExtraService/ExtraServiceExpandImageThreshold";
import ExtraServiceExpandStorageThreshold from "@/views/modal/ExtraService/ExtraServiceExpandStorageThreshold";
import ExtraServiceNvlink from "@/views/modal/ExtraService/ExtraServiceNvlink";
import ExtraServiceParsec from "@/views/modal/ExtraService/ExtraServiceParsec";
import ExtraServiceHardwareChange from "@/views/modal/ExtraService/ExtraServiceHardwareChange";
import ExtraServiceLicense from "@/views/modal/ExtraService/ExtraServiceLicense";

export default {

    extends: baseExtraService,

    components: {
        ExtraServiceHistory,
        SelectionExtraService,
        ExtraServiceExpandImageThreshold,
        ExtraServiceExpandStorageThreshold,
        ExtraServiceNvlink,
        ExtraServiceParsec,
        ExtraServiceHardwareChange,
        ExtraServiceLicense,
    },

    data() {

        return {
            extraServiceTab: EXTRA_SERVICE_TAB,

            activeName: EXTRA_SERVICE_TAB.SELECTION_EXTRA_SERVICE,

            extraServiceExpandImageThresholdKey: 0,
            extraServiceExpandStorageThresholdKey: 0,
            extraServiceNvlinkKey: 0,
            extraServiceParsecKey: 0,
            extraServiceHardwareChangeKey: 0,
            extraServiceLicenseKey: 0,
        };
    },

    props: {
        element: {
            type: Object,
            default: null,
        },
    },

    watch: {
        element: function (newVal, oldVal) {
            // if (newVal) {
            //     if (newVal.changeTab)
            // };
        }
    },

    methods: {

        //#region Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },
        //#endregion

        //#region Action
        action(param) {
            let action = this.$action;
            switch (param.type) {
                case action.OPEN_POPUP_EXTRA_SERVICE_EXPAND_IMAGE_THRESHOLD:
                    this.processOpenPopup(POPUP_ID.EXTRA_SERVICE_EXPAND_IMAGE_THRESHOLD, POPUP_NAME.EXTRA_SERVICE_EXPAND_IMAGE_THRESHOLD);
                    break;
                case action.OPEN_POPUP_EXTRA_SERVICE_EXPAND_STORAGE_THRESHOLD:
                    this.processOpenPopup(POPUP_ID.EXTRA_SERVICE_EXPAND_STORAGE_THRESHOLD, POPUP_NAME.EXTRA_SERVICE_EXPAND_STORAGE_THRESHOLD);
                    break;
                case action.OPEN_POPUP_EXTRA_SERVICE_OPEN_PORT:
                    EventBus.$emit("processingEventApp", {
                        event: "processOpenPopup",
                        data: {
                            type: POPUP_ID.EXTRA_SERVICE_OPEN_PORT,
                            name: POPUP_NAME.EXTRA_SERVICE_OPEN_PORT,
                        },
                    });
                    break;
                case action.OPEN_POPUP_EXTRA_SERVICE_NVLINK:
                    this.processOpenPopup(POPUP_ID.EXTRA_SERVICE_NVLINK, POPUP_NAME.EXTRA_SERVICE_NVLINK);
                    break;
                case action.OPEN_POPUP_EXTRA_SERVICE_PARSEC:
                    this.processOpenPopup(POPUP_ID.EXTRA_SERVICE_PARSEC, POPUP_NAME.EXTRA_SERVICE_PARSEC);
                    break;
                case action.OPEN_POPUP_EXTRA_SERVICE_HARDWARE_CHANGE:
                    this.processOpenPopup(POPUP_ID.EXTRA_SERVICE_HARDWARE_CHANGE, POPUP_NAME.EXTRA_SERVICE_HARDWARE_CHANGE);
                    break;
                case action.OPEN_POPUP_EXTRA_SERVICE_LICENSE:
                    this.processOpenPopup(POPUP_ID.EXTRA_SERVICE_LICENSE, POPUP_NAME.EXTRA_SERVICE_LICENSE);
                    break;
            }
        },
        //#endregion

        //#region Process open pop-up
        processOpenPopup(type, name, refresh) {
            if (refresh === undefined || refresh === null) refresh = true;
            this.openPopup(type);
            if (refresh)
                this[
                    `${name.charAt(0).toLowerCase() + name.slice(1)}Key`
                ] += 1;
        },
        //#endregion 
    },
}